import { getJSON } from 'common/services/api'
import { useQuery } from 'react-query'
import {
  INVOICING_CHARGE_RATE_EXISTS_QUERY_KEY,
  INVOICING_CHARGE_RATE_EXISTS_URL
} from './queryConstants'

type ChargeRateExistsResponse = {
  exists: boolean
  rate: string | null
  rateType: 'HOURLY' | 'EVENT' | null
}

type UseInvoicingChargeRateExistsParams = {
  subjectId?: string
  fundingTypeId?: string
  eventTypeId?: string
  enabled?: boolean
}

export const useInvoicingChargeRateExists = ({
  subjectId,
  fundingTypeId,
  eventTypeId,
  enabled = true
}: UseInvoicingChargeRateExistsParams) => {
  const hasAllParams = !!subjectId && !!fundingTypeId && !!eventTypeId

  return useQuery<ChargeRateExistsResponse>(
    [
      INVOICING_CHARGE_RATE_EXISTS_QUERY_KEY,
      subjectId,
      fundingTypeId,
      eventTypeId
    ],
    async () => {
      return getJSON({
        url: `${INVOICING_CHARGE_RATE_EXISTS_URL}?subjectId=${subjectId}&fundingTypeId=${fundingTypeId}&eventTypeId=${eventTypeId}`,
        isRota: true
      })
    },
    {
      enabled: enabled && hasAllParams,
      staleTime: 30_000,
      refetchOnWindowFocus: false
    }
  )
}
